<div mat-dialog-title class="title">
    {{ data.answerLabel }}
</div>
<mat-dialog-content>
    <div class="borg-value">{{ data.answerUserData }} / 10</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button (click)="onNoClick()" color="accent">{{ 'Close'|translate }}</button>
</mat-dialog-actions>
